module.exports = __webpack_public_path__ + "img/22_15.d97183a2.png";